

























































































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { useMutation, useResult, useQuery } from '@vue/apollo-composable';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import user from '@/table/user';

import getRoles from '@/gql/getRoles.gql';
import getTotalUsers from '@/gql/getTotalUsers.gql';
import getUsers from '@/gql/getUsers.gql';
import updateUser from '@/gql/updateUser.gql';
import deleteUser from '@/gql/deleteUser.gql';

import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import { ToggleButton } from 'vue-js-toggle-button';

const List = defineComponent({
  setup() {
    const { route, router } = useRouter();
    const roleList = [
      { id: 1, totalPeople: '1', name: 'Admin' },
      { id: 2, totalPeople: '2', name: 'Moderator' },
      { id: 3, totalPeople: '3', name: 'Recorder' },
      { id: 4, totalPeople: '4', name: 'Visitor' },
    ];

    const { result: totalUserQuery } = useQuery(getTotalUsers);
    const totalUserResult = useResult(totalUserQuery, { paginatorInfo: { total: 0 } }, (data) => data.users);

    const { result: getRolesQuery } = useQuery(getRoles);
    const rolesResult = useResult(getRolesQuery, [], (data) => data.roles);

    const computedRolesResult = computed(() => {
      if (!(rolesResult.value)) return [];
      const _value = roleList.map((elm: any) => ({
        ...elm,
        totalPeople: rolesResult.value[elm.id - 1]?.users.length || 0,
      }));
      return _value;
    });

    // Search filter
    const search = reactive({
      text: '',
    });
    // Delete Mutation variables
    const deleteItem = reactive({
      id: '',
      name: '',
    });
    // ==== Delete Mutation ==== //
    const deleteMutation = useMutation(
      deleteUser,
      () => ({
        variables: {
          id: deleteItem.id,
        },
        refetchQueries: ['getUsers', 'getRoles'],
      }),
    );
    function setRemoveItem(item: any) {
      deleteItem.id = item.id;
      deleteItem.name = `${item.firstName} ${item.lastName}`;
    }

    // Active Deactive Mutation
    const toggleVariables = reactive({
      id: '',
      status: true,
    });
    const updateUserMutation = useMutation(
      updateUser,
      () => ({
        variables: {
          id: toggleVariables.id,
          active: !(toggleVariables.status),
        },
        refetchQueries: ['getUsers', 'getRoles'],
      }),
    );
    function setActiveStatus(id: any, status: boolean) {
      toggleVariables.id = id;
      toggleVariables.status = status;
      updateUserMutation.mutate();
    }

    // ==== View Item ==== //
    function viewItem(item: any) {
      router.push({ name: 'UserView', params: { userId: item?.item.id } });
    }

    // ==== Use to search User ==== //
    const usersListVariables = computed(() => {
      const vars: {[key: string]: any} = {
        searchName: undefined,
        filterRoleId: route.value.params.roleId,
      };
      if (search.text) {
        vars.searchName = `%${search.text}%`;
      }
      return vars;
    });

    // ==== Use Format ==== //
    function useDateTimeFormat(date: any) {
      if (!date) return '';
      return `${useFormat.date(date).displayShortThaiDate()} เวลา ${date.substring(11, 16)}`;
    }

    return {
      rolesResult,
      computedRolesResult,
      totalUserResult,
      userTableOption: user,
      getUsersQuery: getUsers,
      getUsersResult: (data: any) => data.users,
      roleList,
      search,
      deleteItem,
      setRemoveItem,
      usersListVariables,
      deleteMutation,
      viewItem,
      setActiveStatus,
      useDateTimeFormat,
    };
  },
  components: {
    CommonConfirmDialog,
    ToggleButton,
  },
  props: {
    role: {},
  },
});

export default List;
